import { apiSlice } from '@/store/api/apiSlice';

interface PlanetAstaItem {
  startTime: string;
  endTime: string;
  totalDuration: string;
}

export interface PlanetAstaResponse {
  planetName: string;
  asta: PlanetAstaItem[];
}

export const planetAstaTransitApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetAstaTransit: builder.query<PlanetAstaResponse[], void>({
      query: () => ({
        url: '/transits/planet-ashta',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPlanetAstaTransitQuery } = planetAstaTransitApi;
